import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';

import { MenuStore } from '../../../store/menu.store';
import { Mat3ButtonComponent } from '../../base-components/mat3-button/mat3-button.component';

@Component({
  selector: 'app-search-dialog',
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatDividerModule,
    Mat3ButtonComponent,
  ],
  templateUrl: 'search-dialog.component.html',
  styleUrls: ['search-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<SearchDialogComponent>);
  private menuStore = inject(MenuStore);

  public searchText = signal('');

  public navItemsData = computed(() => {
    const visibleSections = this.menuStore.visibleMenuSections();
    return visibleSections.filter((section) => section.children && section.children.length > 0);
  });

  onSearchTextChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.searchText.set(target.value);
  }
}
